import { RootState } from "./store";
import { NETWORK_TYPE, NetworkType } from "utils/network";

/** Raw preference — read via useSettlementToken, which validates it against the live list. */
export const settlementTokenAddressSelector = (state: RootState) =>
  state.user.settlementTokenAddress;

export const treasuryIdSelector = (state: RootState) => state.user.treasuryId;
export const authUidSelector = (state: RootState) => state.user.authUid;
export const networkSelector = (state: RootState) => state.user.network;

/**
 * The network to send to the API. Returns a plain string, so components can
 * subscribe to it without a memoised selector.
 */
export const networkTypeSelector = (state: RootState): NetworkType =>
  state.user.network?.value ?? NETWORK_TYPE;
export const deployedBalanceSelector = (state: RootState) =>
  state.user.deployedBalance;
export const userTypeSelector = (state: RootState) => state.user.userType;
